module.exports = __webpack_public_path__ + "img/fbzl.5dc1228.png";